export default {
  test: "테스트"
};
